class DiagramViews {

    public items: DiagramView[] = []

    constructor() {
        this.items.push({
            id: 1,
            type: DiagramType.Spider,
            name: 'Spinne - Thema',
            url: 'projectTopicGroupsTopics',
            tag: '',
        })
        this.items.push({
            id: 2,
            type: DiagramType.Spider,
            name: 'Spinne - Stakeholder',
            url: 'projectStakeholderGroupStakeholders',
            tag: '',
        })
        this.items.push({
            id: 3,
            type: DiagramType.Spider,
            name: 'Spinne - Maßnahme',
            url: 'projectActionGroupsActions',
            tag: '',
        })
        // this.items.push({
        //     id: 4,
        //     type: DiagramType.Spider,
        //     name: 'Spinne - Thema/Maßnahme',
        //     url: 'projectTopicsActions',
        // })
        // this.items.push({
        //     id: 5,
        //     type: DiagramType.Spider,
        //     name: 'Spinne - Stakeholder/Maßnahme',
        //     url: 'projectStakeholdersActions',
        // })
        // this.items.push({
        //     id: 6,
        //     type: DiagramType.Spider,
        //     name: 'Spinne - Thema/Stakeholder',
        //     url: 'projectTopicsStakeholders',
        // })
        // this.items.push({
        //     id: 7,
        //     type: DiagramType.Spider,
        //     name: 'Spinne - Stakeholder/Thema',
        //     url: 'projectStakeholdersTopics',
        // })
        // this.items.push({
        //     id: 8,
        //     type: DiagramType.Spider,
        //     name: 'Spinne - Maßnahme/Stakeholder',
        //     url: 'projectActionsStakeholders',
        // })
        this.items.push({
            id: 9,
            type: DiagramType.MessageSpider,
            name: 'Botschaftenspinne - Thema/Botschaft Proaktiv',
            url: 'projectTopicGroupsTopics',
            tag: 'proactive',
        })
        this.items.push({
            id: 15,
            type: DiagramType.MessageSpider,
            name: 'Botschaftenspinne - Thema/Botschaft Reaktiv',
            url: 'projectTopicGroupsTopics',
            tag: 'reactive',
        })
        this.items.push({
            id: 10,
            type: DiagramType.Matrix,
            name: 'Matrix - Maßnahme/Stakeholder',
            url: 'stakeholdersActions',
            tag: '',
        })
        this.items.push({
            id: 11,
            type: DiagramType.Matrix,
            name: 'Matrix - Maßnahme/Thema',
            url: 'topicsActions',
            tag: '',
        })
        this.items.push({
            id: 12,
            type: DiagramType.Matrix,
            name: 'Matrix - Thema/Stakeholder',
            url: 'stakeholdersTopics',
            tag: '',
        })
        this.items.push({
            id: 13,
            type: DiagramType.Bubble,
            name: 'Bubble - Stakeholdergruppen',
            url: 'stakeholderGroups',
            tag: '',
        })
        this.items.push({
            id: 14,
            type: DiagramType.Timeline,
            name: 'Timeline - Maßnahme',
            url: 'actions',
            tag: '',
        })
    }
}

export enum DiagramType {
    Spider = 0,
    MessageSpider = 1,
    Matrix = 2,
    Bubble = 3,
    Timeline = 4,
}

export class DiagramView {
    public id = 0
    public type = DiagramType.Spider
    public name = ''
    public url = ''
    public tag = ''
}

export let diagramViews = new DiagramViews()
